import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { BasicModal } from './BasicModal';
import { Typography } from './Typography';

type RoutineSetModalProps = {
  isOpen: boolean;
  onClose: () => void;
  products: Array<{ label: string; routine: string; type: string }>;
  title: string;
};

const Title = styled(Typography)`
  font-size: 12px;
  color: ${theme.colors.primary[300]};
  font-weight: 500;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing['6x']};
`;

const Label = styled(Typography)`
  color: ${theme.colors.primary[300]};
  font-size: 10px;
  margin-bottom: ${theme.spacing['2x']};
`;

const Routine = styled(Typography)`
  color: ${theme.colors.primary[300]};
`;

export const RoutineSetModal = ({ isOpen, onClose, products, title }: RoutineSetModalProps) => (
  <BasicModal isOpen={isOpen} onClose={onClose}>
    <Container>
      <Title variant="mono2">{title}</Title>
      {products.map((product) => (
        <div key={product.type}>
          <Label variant="mono3">{product.label?.toUpperCase()}</Label>

          <Routine variant="p3">{product.routine}</Routine>
        </div>
      ))}
    </Container>
  </BasicModal>
);
